import React, {useMemo} from 'react'
import Teaser from '../../components/cms/teaser'
import PropTypes from 'prop-types'
import ModuleContainer from '../../components/module-container'
import Heading from '../../components/cms/heading'
import teaserListSlotRecipe from './index.recipe'
import {Box, useSlotRecipe} from '@chakra-ui/react3'
import {hasValidString, parseAspectRatio} from '../../utils/utils'
import Copy from '../../components/cms/copy'
import Fade from '../../components/cms/fade'

const TeaserList = React.forwardRef(
    (
        {
            moduleId,
            moduleType,
            pageId,
            background,
            anchor,
            headingLevel,
            heading,
            copy,
            teaserList,
            imageRatio,
            teaserBackground,
            spacing
        },
        ref
    ) => {
        const recipe = useSlotRecipe({recipe: teaserListSlotRecipe})

        const isOneTeaser = teaserList.length === 1
        const styles = useMemo(() => recipe({isOneTeaser}), [recipe, isOneTeaser])

        const hasCopyText = hasValidString(copy?.text)

        return (
            <ModuleContainer
                moduleId={moduleId}
                moduleType={moduleType}
                pageId={pageId}
                anchor={anchor}
                background={background}
                spacing={spacing}
                css={styles.root}
                ref={ref}
            >
                <Box css={styles.heading}>
                    <Fade>
                        <Heading {...heading} alignment="inherit" headingLevel={headingLevel} />
                    </Fade>
                    {hasCopyText && (
                        <Fade>
                            <Box css={styles.copy}>
                                <Copy {...copy} alignment="inherit"></Copy>
                            </Box>
                        </Fade>
                    )}
                </Box>
                <Box css={styles.teasersContainer}>
                    {teaserList.map((teaser, index) => (
                        <Teaser
                            key={index}
                            {...teaser}
                            aspectRatio={parseAspectRatio(imageRatio)}
                            teaserBackground={teaserBackground}
                            widths={{
                                base: '88vw',
                                s: `${Math.ceil(87.5 / Math.max(2, teaserList.length))}vw`,
                                l: Math.ceil(1680 / Math.max(2, teaserList.length))
                            }}
                            trackingContext={{moduleName: moduleType, eventLabel: 'cta'}}
                            headingLevel={headingLevel}
                        />
                    ))}
                </Box>
            </ModuleContainer>
        )
    }
)

if (process.env.NODE_ENV !== 'production') {
    TeaserList.displayName = 'TeaserList'
}

TeaserList.propTypes = {
    anchor: PropTypes.string,
    background: PropTypes.string,
    headingLevel: PropTypes.number,
    heading: PropTypes.object,
    copy: PropTypes.object,
    teaserList: PropTypes.array,
    imageRatio: PropTypes.string,
    teaserBackground: PropTypes.bool,
    moduleId: PropTypes.string,
    moduleType: PropTypes.string,
    pageId: PropTypes.string,
    spacing: PropTypes.oneOf(['default', 'reduced', 'min', 'min-top', 'min-bottom'])
}

export default TeaserList
